<template>
  <div id="app">
    <v-card class="elevation-0">
      <div style="font-size: 1.25rem" class="px-4 font-weight-bold">
        {{ $vuetify.lang.t("$vuetify.ai_response.search_endpoints") }}
      </div>
      <v-row class="ml-2">
      <v-col cols="8" xs="12">
        <v-select v-model="selectedEndpoint" :items="SEARCH_ENDPOINTS"
          :label='$vuetify.lang.t("$vuetify.ai_response.select_endpoint")' outlined required
          item-text="endpoint_name"
          item-value="endpoint_value"
          >
        </v-select>
      </v-col>
    </v-row>
    <template v-if="selectedEndpoint === '/v1/items/search'">
          <ItemsSearch ref="itemsSearchRef" :mapper="mapper" :catalogItems="catalogItems"  />
      </template>
      <template v-if="selectedEndpoint === '/v1/images/search'">
          <ImageSearch ref="imageSearchRef" :mapper="mapper" :catalogItems="catalogItems"  />
      </template>
      <template v-if="selectedEndpoint === '/v1/users/keywords'">
          <UsersKeywords ref="usersKeywordsRef" :mapper="mapper" :catalogItems="catalogItems"  />
      </template>
      <template v-if="selectedEndpoint === '/v1/categories/keywords'">
          <CategoriesKeywords ref="itemPurchaseTogetherRef" :mapper="mapper" :catalogItems="catalogItems"  />
      </template>
    </v-card>
  </div>
</template>

<script>
import { GET_MAPPER, GET_CATALOG_ITEMS, ADD_ALERT } from "@/store/_actiontypes";
import { mapState, mapActions } from "vuex";
import ItemsSearch from "@/components/Projects/Search/Endpoints/ItemsSearch"
import ImageSearch from "@/components/Projects/Search/Endpoints/ImageSearch"
import UsersKeywords from "@/components/Projects/Search/Endpoints/UsersKeywords"
import CategoriesKeywords from "@/components/Projects/Search/Endpoints/CategoriesKeywords"

export default {
  components: {
    ItemsSearch,
    ImageSearch,
    UsersKeywords,
    CategoriesKeywords
  },
  data() {
    return {
      selectedEndpoint: "",
      catalogItems: [],
      SEARCH_ENDPOINTS: [
        {
          endpoint_name: this.$vuetify.lang.t("$vuetify.ai_response.image_search"),
          endpoint_value: "/v1/images/search"
        },
        {
          endpoint_name: this.$vuetify.lang.t("$vuetify.ai_response.items_search"),
          endpoint_value: "/v1/items/search"
        },
        {
          endpoint_name: this.$vuetify.lang.t("$vuetify.ai_response.users_keywords"),
          endpoint_value: "/v1/users/keywords"
        },
        {
          endpoint_name: this.$vuetify.lang.t("$vuetify.ai_response.categories_keywords"),
          endpoint_value: "/v1/categories/keywords"
        },

      ]
    };
  },
  computed: {
    ...mapState({
      selectedProject: (state) => state.project.selectedProject,
      user: (state) => state.account.user
    }),
  },
  mounted() {
    this.getMapper()
    this.getCatalogItems()
  },
  methods: {
    ...mapActions("project", [GET_MAPPER]),
    ...mapActions("ai_response", [GET_CATALOG_ITEMS]),
    ...mapActions("alert", [ADD_ALERT]),
    getMapper() {
      this.getMapperFunction();
    }, 
    getMapperFunction() {
      this.GET_MAPPER({
        project_id: this.selectedProject.id,
      }).then(
        (response) => {
          this.mapper = response.data.detail.response
        },
        (error) => {
          console.error("error", error)
          if(error.status === 422){
            this.$store.dispatch(
                  `alert/${ADD_ALERT}`, {
                    message: JSON.stringify(error?.response?.data?.detail),
                    color: "error",
                  }, { root: true }
                );
          } else {
            this.$store.dispatch(
                  `alert/${ADD_ALERT}`, {
                    message: error?.response?.data?.detail?.response,
                    color: "error",
                  }, { root: true }
            );
          }
        }
      );

    },
    getCatalogItems(){
      this.getCatalogItemsFunction();
    },
    getCatalogItemsFunction(){
      this.GET_CATALOG_ITEMS({
        project_id: this.selectedProject.id,
      }).then(
        (response) => {
          this.catalogItems = response.data.detail.response?.items
        },
        (error) => {
          console.error("error", error)
          if(error.status === 422){
            this.$store.dispatch(
                  `alert/${ADD_ALERT}`, {
                    message: JSON.stringify(error?.response?.data?.detail),
                    color: "error",
                  }, { root: true }
                );
          } else {
            this.$store.dispatch(
                  `alert/${ADD_ALERT}`, {
                    message: error?.response?.data?.detail?.response,
                    color: "error",
                  }, { root: true }
            );
          }
        }
      );
    },
    handleClick() {
      this.message = 'Button Clicked!';
    }
  }
};
</script>

<style scoped>

</style>
